import { CheckCircle, X } from "lucide-react";

/** Small shared cell icon for the feature comparison table. */
export function CellIcon({ val }) {
  if (val === true) return <CheckCircle className="w-5 h-5 text-emerald-400 mx-auto" />;
  if (val === false) return <X className="w-5 h-5 text-[var(--color-text-muted)] mx-auto" />;
  return <span className="text-xs text-yellow-500 font-mono uppercase">{val}</span>;
}
